<template>
    <el-dialog
        title="队员信息确认"
        :visible.sync="dialogVisible"
        width="783px"
        :destroy-on-close="true"
        class="comfirm-form"            
        >
        <div class="comfirm-info form-view">
            <div class="wrapper"></div>
            <div class="header"></div>
            <div class="form">
            <el-form ref="comfirmForm" :model="comfirm_form" :rules="rules" label-width="250px">
                <el-form-item label="游戏ID" prop="account">
                    <el-input v-model="comfirm_form.account" :readonly="true" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="比赛大区" prop="zid">
                    <el-select v-model="comfirm_form.zid" placeholder="请选择比赛大区" @change="queryPlayerInfo(comfirm_form.account)">
                        <el-option v-for="(item,index) in area_data" :key="index" v-bind:label="item.name" v-bind:value="item.id"></el-option>
                    </el-select>
                </el-form-item>                  

                <el-form-item label="游戏昵称" prop="nickName">
                    <el-input v-model="comfirm_form.nickName" :readonly="true" :disabled="true"></el-input>
                </el-form-item>

                <el-form-item label="真实姓名" prop="realName">
                    <el-input v-model="comfirm_form.realName"></el-input>
                </el-form-item>                             

                <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="comfirm_form.phone"></el-input>
                </el-form-item>

                <el-form-item label="身份证号码" prop="idCard">
                    <el-input v-model="comfirm_form.idCard"></el-input>
                </el-form-item>
            </el-form>
            </div>


            <div class="check-view">
                <div class="v-code"><span class="tag">验证码：</span><div class="input"><input type="text" name="vcode" @blur="vcheck" v-model="vcode"></div><span class="img-box"><img v-bind:src="img"></span><span class="vcode-flesh" @click="re_code">换一个</span></div>
                <div class="check-box"><em class="box"><input type="checkbox" name="rule-check" v-model="rule_check"></em><span class="u-rule"><a href="https://www.m3guo.com/v2/news/report/1646991187.html" target="_blank">我已阅读并同意遵守《烽火杯赛事规则》</a></span></div>
            </div>
            <div class="u-btn submit" @click="submit_handler()">确认提交</div>               

        </div>

          
    </el-dialog>    
</template>

<style scoped>
.comfirm-info{
    position: relative;
    width: 769px;
    height: 635px;
    margin: 5px auto;
    z-index: 2;       
}

.wrapper{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    height: 100%;
    background-image: url(~@/assets/images/wrapper-form.png);
    z-index: 2;
    pointer-events: none;       
}

.header{
    width: 769px;
    height: 45px;
    margin: 0 auto 30px;
    background-image: url(~@/assets/images/header-check.png);
}

.form{
    margin-left: 45px;
}
</style>

<script>
export default {
    data () {
        return {
            dialogVisible: false,
            ua : () => {},
            comfirm_form : {
                account : '',
                nickName : '',
                zid : '',
                realName : '',
                phone : '',
                idCard : '',
            },
            area_data : this.$global.areaList,
            rules: this.$global.formRules,
            id : '',
            playerData : {},
            vcode : '',
            bcheck : '',
            img : this.$ajax_url_map.vcode,
            rule_check : false,
            validate : false,                  
        }
    },
    created (){
        this.id = this.playerData.id;
        this.comfirm_form.account = this.playerData.account;
        this.comfirm_form.nickName = this.playerData.nick;
        //this.comfirm_form.corpName = this.playerData.corpName;
        //this.comfirm_form.maxEquipScore = this.playerData.maxEquipScore;
    },
    methods : {
        vcheck (){
            if(!this.vcode)return;
            this.$axios.get(this.$ajax_url_map.vcode_check,{
                params : {
                    captcha : this.vcode,
                }
            })
            .then(res => {
                if(res.data.code == this.$ajax_code.success && res.data.data){
                    this.bcheck = true;
                    return true;
                }
                else{
                    this.$message.error('验证码有误');
                    return false;
                }                                
            });
        },
        re_code (){
            this.img = this.$ajax_url_map.vcode + '?r=' + new Date().getTime();
        },
      form_check (name){
        var self = this; 
        this.$refs[name].validate((valid) => {
          if(valid){
              self.validate = true;
          }
        });
      },
      queryPlayerInfo (id){
          if(!id)return;
          if(!this.comfirm_form.zid)return;

          let self = this;

          this.$axios.get(this.$ajax_url_map.query,{
              params : {
                  account : this.comfirm_form.account,
                  zid : this.comfirm_form.zid,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success){
                  //success
                  self.comfirm_form.nickName = res.data.data.charName;
                  this.$message.success('查询成功');
              }
              else{
                  self.comfirm_form.nickName = '';              
                  this.$message.error(res.data.message);
              }
          });
      },      
      submitForm (){

        if(!this.rule_check)return this.$message.error('请确认阅读并同意遵守烽火杯赛事规则');
        if(!this.bcheck )return this.$message.error('请填写验证码');

        this.form_check('comfirmForm');

        let data = {
            "id": this.id, //玩家ID
            "account": this.comfirm_form.account, //玩家数字ID
            "realName": this.comfirm_form.realName, //真实姓名
            "phone": this.comfirm_form.phone, //手机号
            "idCard": this.comfirm_form.idCard, //身份证号码 
            "zid" :  this.comfirm_form.zid,//大区id                 
        }

        if(this.validate){
            this.$axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'post',
                url: this.$ajax_url_map.confirm,
                data: JSON.stringify(data)
            })
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    this.dialogVisible = false;
                    //this.$message.success(res.data.message);
                    this.$ua_update({
                        role : 2,
                        state : true,
                    });
                    
                    this.$success_modal_member();                    

                }
                else{
                    this.$message.error(res.data.message);
                }
            })
            .catch(err=>{
                this.$message.error('请稍后再试');
                console.error(err);
            })             
        }
        else{
            this.$message.error('报名信息有误，请仔细查阅报名要求');
        }
      },
      submit_handler(){
          var self = this;
          if(!this.vcode)return this.$message.error('请填写验证码');
          this.$axios.get(this.$ajax_url_map.vcode_check,{
              params : {
                  captcha : this.vcode,
              }
          })
          .then(res => {
              if(res.data.code == this.$ajax_code.success && res.data.data){
                  this.bcheck = true;
                  self.submitForm();
              }
              else{
                  this.$message.error('验证码有误');
              }              
          });          
      },                             
    },
}
</script>


// WEBPACK FOOTER //
// src/components/joinModal/joinModal.vue